/** Created by azhou on 2019/3/18.*/
<template>
    <div>
      <ul class="list-item">
        <li class="w-50 list-item-col flex-wrap">
          <el-popover placement="right" trigger="hover">
              {{cardItem.oid}}<span slot="reference">{{cardItem.oid | formatString(13)}}</span>
          </el-popover>
          <el-popover placement="right" trigger="hover" v-if="storeInfo.type != 2" class="w-100">
              {{cardItem.company}}<span slot="reference">{{cardItem.company | formatString(7)}}</span>
          </el-popover>
          <el-popover placement="right" trigger="hover" v-if="isAdmin || storeInfo.type == 2"  class="w-100">
              {{cardItem.title || cardItem.homestayTitle}}<span slot="reference">{{(cardItem.title || cardItem.homestayTitle) | formatString(7)}}</span>
          </el-popover>
        </li>
        <li class="w-50 list-item-col" v-if="isGroup">{{cardItem.appoint_name || cardItem.company}}</li>
        <li class="w-50 list-item-col">
          {{cardItem.date_in | formatTimestamp}} 至 {{cardItem.date_out | formatTimestamp}}
            共 {{(cardItem.date_out - cardItem.date_in)/86400}} 晚
        </li>
        <!-- <li class="w-50 list-item-col">{{cardItem.num}}人</li> -->
        <li class="w-50 list-item-col">{{cardItem.time | formatTimestamp(1)}}</li>
        <li class="w-50 list-item-col">&yen; {{Total(cardItem.price,cardItem.continued_price)}} / &yen; {{Total(cardItem.price_pay,cardItem.continued_pay)}}</li>
        <li class="w-50 list-item-col">
          {{cardItem.guide_name || '待添加'}}<br />
          {{cardItem.guide_mobile}}
        </li>
        <li class="w-50 list-item-col">
          <span :class="['ml-2',$GFUN.FormatColor(cardItem.status)]">
            <label v-if="cardItem.status == 8 && storeInfo.type == 2">待付款</label>
            <label v-else>{{cardItem.status | formatVar('HOrderStatus')}}</label>
          </span>
        </li>
        <li class="w-50 list-item-col"><span class="text-link" @click="$emit('goForDetail',cardItem)">查看</span></li>
      </ul>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'HomestayOrderCard',
    props: {
      cardItem: {}
    },
    computed: {
      ...mapGetters(['storeInfo','isGroup','isAdmin'])
    },
    methods: {
      Total(a,b) {
        if(typeof(a) == 'number') a = a / 100
        if(typeof(b) == 'number') b = b / 100
        return (Number(a) + Number(b)).toFixed(2)
      }
    }
  }
</script>

<style lang="scss" scoped>
.list-item-col{
  border-right: 0
}
</style>
